<template>
<!--    <li v-if="showButton" class="nav-item d-none d-lg-flex align-items-center">-->
<!--        <a role="button" href="mailto:support@kidsday.io" class="btn btn-success px-3 btn-sm nav-link me-2">-->
<!--            {{ trans('general.upgrade_now') }}-->
<!--        </a>-->
<!--    </li>-->
</template>

<script>
export default {
    name: "trial-alert",
    data() {
        return {
            showButton: false,
        }
    },
    methods: {
        changeState(state) {
            this.showButton = state;
        }
    },
}
</script>
